import { combineReducers } from '@reduxjs/toolkit';
import roomReducer from "../feature/admin/room/RoomSlice"
import staffReducer from "../feature/admin/staff/StaffSlice"
import dashboardReducer from "../feature/admin/dashboard/DashboardSlice"
import mealReducer from "../feature/admin/meals/MealSlice"
import curriculumReducer from '../feature/admin/curriculum/CurriculumSlice'
import childrenReducer from "../feature/admin/children/ChildSlice"
import newsLetterReducer from '../feature/admin/news/NewsLetterSlice'
import invoiceReducer from "../feature/admin/invoice/InvoiceSlice"
import activityReducer from "../feature/admin/activity/ActivitySlice"
import documentReducer from '../feature/admin/allDocuments/AllDocumentsSlice'
import eventReducer from '../feature/admin/event/EventSlice'
import incidentReducer from '../feature/admin/incidentAndBehavior/IncidentSlice'
import leaveRequestReducer from "../feature/admin/leaveRequest/LeaveSlice"
import StaffDashboardReducer from '../feature/staffs/dashboard/DashboardSlice';
import myAttendanceReducer from "../feature/staffs/myAttendance/MyAttendanceSlice";
import childAttendanceReducer from "../feature/admin/children/ChildAttendanceSlice";
import payrollReducer from "../feature/admin/hrPayroll/PayrollSlice";
import profileReducer from "../feature/staffs/profiles/ProfileSlice";
import cmsReducer from "../feature/admin/cms/CMSSlice";
import reportReducer from "../feature/admin/reports/ReportSlice";
import recentActivityReducer from "../feature/admin/recentActivity/RecentActivitySlice";
import adminProfileReducer from "../feature/admin/profiles/ProfileSlice";
import parentProfileReducer from '../feature/parents/profiles/ProfileSlice';
import parentChildAttendanceReducer from '../feature/parents/ParentChildAttendance/ParentChildAttendanceSlice';
import emergencyContactReducer from '../feature/parents/emergencyContact/ContactSlice';
import authorisedPickupReducer from '../feature/parents/emergencyContact/AuthorisedSlice';
import unauthorisedPickupReducer from '../feature/parents/emergencyContact/UnauthorisedSlice';
import assginKioskReducer from '../feature/admin/assignKiosk/KioskSlice';
import messasingReducer from "../feature/admin/messasing/MessasingSlice";
import notesReducer from "../feature/admin/dashboard/NotesSlice";
import leaveCalenderReducer from "../feature/admin/leaveRequest/LeaveCalenderSlice";
import parentDashboardReducer from '../feature/parents/dashboard/DashboardSlice';
const rootReducer = combineReducers({
  rooms: roomReducer,
  staffs: staffReducer,
  dashboards: dashboardReducer,
  meals: mealReducer,
  curriculums: curriculumReducer,
  children: childrenReducer,
  news: newsLetterReducer,
  invoices: invoiceReducer,
  activities: activityReducer,
  documents: documentReducer,
  events: eventReducer,
  incidents: incidentReducer,
  leaveRequests: leaveRequestReducer,
  childAttendances: childAttendanceReducer,
  payrolls: payrollReducer,
  staffDashboards: StaffDashboardReducer,
  myAttendances: myAttendanceReducer,
  profiles: profileReducer,
  adminProfiles: adminProfileReducer,
  cms: cmsReducer,
  reports: reportReducer,
  recents: recentActivityReducer,
  kiosk: assginKioskReducer,

  parentProfile: parentProfileReducer,
  parentChildAttendance: parentChildAttendanceReducer,
  emergencyContact: emergencyContactReducer,
  authorisedPickup:authorisedPickupReducer,
  unauthorisedPickup:unauthorisedPickupReducer,

  chats: messasingReducer,
  notes: notesReducer,
  leaveCalender: leaveCalenderReducer,
  parentDashboard: parentDashboardReducer,
});

export default rootReducer;
